import React from 'react';
import { useRouter } from 'next/router';

const isProd = process.env.NODE_ENV === 'production';

const Link: React.FC<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>> = ({
  href,
  children,
  ...otherProps
}) => {
  const router = useRouter();

  const handleClick = (e) => {
    if (!isProd) {
      e.preventDefault();
      router.push(decodeURIComponent(href));
    }
  };

  return (
    <a href={href} onClick={handleClick} {...otherProps}>
      {children}
    </a>
  );
};

export default React.memo(Link);
